<template>
<div>

 <div class="box" v-if="textArr.length && text">
    <div class="textBox">
      <transition name="slide">
        <p class="text" :key="text.id"   @click="swiperClick(text.id)">
          <img src="../assets/images/notice.png" alt="">
            {{text.val && text.single}}
        </p>
      </transition>
    </div>
  </div>


  <el-dialog :visible.sync="show" :title="info.title">
    <div class="cont" v-if="info" v-html="info.content"> </div>
  </el-dialog>
</div>
 
</template>

<script>
export default {
  name: 'scroll',
  data () {
    return {
      textArr: [],
      number: 0,
      show: false,
      info: {}
    }
  },
  computed: {
    text () {

      if(this.textArr.length) {
        let single =  this.textArr[this.number].title.length > 20 ?  this.textArr[this.number].title.substr(0, 20) + '......' : this.textArr[this.number].title
        return {
          id:this.textArr[this.number].id,
          val: this.textArr[this.number],
          single
        }
      }
      
    }
  },
  mounted () {
    this.getlist()
  },
  methods: {
    getlist() {
      this.$api.notice().then(res => {
        if(res.status) {
          this.textArr = res.data
          if(res.data.length) {
            this.startMove()
          }
        }
      })
    },
    swiperClick(id) {

      let data = {
				id
			};
			this.$api.noticeInfo(data).then(res => {
				if (res.status) {
					this.info = res.data;
        //  let  content = "阳光义卖使用公司对公账户作为收款渠道，公司法律合规事务部、财务平台将对义卖收退款、收款账户、资金流向及运营流程进行统一监督管控。\n\n同时，也欢迎广大同学一同监督我们，让阳光义卖活动可以做的更好！\n\n举报邮箱：jubao@meituan.com\n举报链接：jubao.meituan.com"

          // this.info.content = this.info.content.replaceAll('\n', '<br>')
          this.info.content = this.info.content.replace(/\n/g, '<br>')

          this.show = true
				} 
			});
    },
    startMove () {
      // eslint-disable-next-line
      let timer = setInterval(() => {
        if (this.number === this.textArr.length - 1) {
          this.number = 0;
        } else {
          this.number += 1;
        }
      }, 5000); // 滚动不需要停顿则将2000改成动画持续时间
    }
  }
}
</script>

<style scoped lang="scss">
.box {
  background: #fff;
}
.cont {
  padding: 20px;
  min-height: 100px;
  line-height: 20px;
}
  .textBox {
    width: 1226px;
    height: 40px;
    margin: 0 auto;
    overflow: hidden;
    position: relative;
    img {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
  }
  .text {
    width: 100%;
    position: absolute;
    cursor: pointer;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
  }
  .slide-enter-active, .slide-leave-active {
    transition: all 0.5s linear;
  }
  .slide-enter{
    transform: translateY(20px) ;
    opacity: 1;
  }
  .slide-leave-to {
    transform: translateY(-20px) ;
    opacity: 0;
  }
</style>